import CustomButton from "../CustomButton";
import { ListContainer, UploadFiles } from "./styles";

const UPCList = (props) => {
  return (
    <ListContainer>
      <ul>
        {props.upcExisting.map((upc) => (
          <li key={upc}>{upc}</li>
        ))}
      </ul>
      <p>Estos UPC se encontraban en plataforma.</p>
      {props.isOrder && (
        <p>Para la orden se utilizarán los UPC ya existentes</p>
      )}
      <UploadFiles>
        <CustomButton
          variant="pink"
          label="Continuar"
          onClick={() => {
            if (props.isOrder) props.createOrder();
            else props.setRedirect("products");
          }}
        />
      </UploadFiles>
    </ListContainer>
  );
};
export default UPCList;